import React from "react";

const MainContent = ({ children, className = "", variant = "default" }) => {
  const isParentVariant = variant === "parent";

  return (
    <div className={`pb-20 px-12 flex justify-center ${className}`}>
      <div
        className={`w-full max-w-7xl p-10 mt-[7rem] ${
          isParentVariant
            ? "rounded-[32px] border border-[#ddd3c6] bg-[linear-gradient(180deg,rgba(255,255,255,0.96),rgba(253,249,242,0.98))] shadow-[0_24px_60px_rgba(11,43,102,0.08)]"
            : "rounded-2xl border-2 border-white bg-transparent shadow-xl backdrop-blur-[2px]"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default MainContent;
